$( document ).ready(function() {
  $('.product-card').each(function(){
    var swatchContainer = $(this).find('.swatches'),
        swatchItem = $(swatchContainer).find('.color-swatch'); 
    if (!swatchItem) return;
    swatchItem.each(function(){      
      var mainImage = $(this).parents('.product-card').find('.product-card--image').find('img');      
      $(this).on('mouseenter', function(){         
        var activeSwatchImage = $(this).attr('data-image')
          mainImage.attr('src',activeSwatchImage);
          mainImage.attr('srcset',activeSwatchImage);
      });
    }); 
  });
});